import * as React from "react";
import { SvcFlow } from '../../../misc/api/apiTypes';

export interface SvcGraphState {
    flow: SvcFlow;
}

const initialState = {
    flow: null,
}

export enum GraphActionTypes {
    LoadInitialVisibility = "LoadInitialVisibility",
    ToggleTestGraphVisibility = "ToggleTestGraphVisibility",
}

export type GraphActions = LoadInitialVisibilityAction | ToggleTestGraphVisibilityAction;

export class LoadInitialVisibilityAction {
    type: GraphActionTypes.LoadInitialVisibility;
    flow: SvcFlow;

    static create(flow: SvcFlow): LoadInitialVisibilityAction {
        return {
            type: GraphActionTypes.LoadInitialVisibility,
            flow: flow,
        };
    }
}

export class ToggleTestGraphVisibilityAction {
    type: GraphActionTypes.ToggleTestGraphVisibility;
    testId: string

    static create(testId: string): ToggleTestGraphVisibilityAction {
        return {
            type: GraphActionTypes.ToggleTestGraphVisibility,
            testId: testId,
        };
    }
}

export const useSvcGraphs = (flowData: SvcFlow): [SvcGraphState, React.Dispatch<GraphActions>] => {
    const reducer = (state: SvcGraphState, action: GraphActions): SvcGraphState => {
        switch (action.type) {
            case GraphActionTypes.LoadInitialVisibility:
                return {
                    ...state,
                    flow: action.flow,
                };
            case GraphActionTypes.ToggleTestGraphVisibility:
                return {
                    ...state,
                    flow: {
                        ...state.flow,
                        Tests: state.flow.Tests.map(t => {
                            if (t.TestId === action.testId) {
                                return {
                                    ...t,
                                    IsDisplayed: !t.IsDisplayed
                                }
                            } else {
                                return t;
                            }
                        })
                    }
                };
            default:
                throw new Error("Unexpected Graph action");
        }
    }

    const [state, dispatch] = React.useReducer(reducer, initialState);

    React.useEffect(() => {
        const hydrateAcceptability = () => {
            dispatch(LoadInitialVisibilityAction.create(flowData));
        };

        hydrateAcceptability();
    }, [flowData])

    return [state, dispatch];
}

